module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0023.jpg?v=a0213295";